// Every row begins with a snapshot of the caller's UserSettings (currency +
// tax regime), then invoice- and transaction-level fields — mirroring the
// columns `transactions_slice_by_range` returns, in the same order.
const userContext = {
  userCurrency: 'GEL',
  userTaxFee: '1',
  userTaxBase: 'turnover',
  userAccountingBasis: 'cash',
  userVatStatus: 'notRegistered',
  userVatBasis: 'invoice',
  userVatThreshold: '100000',
  userVatThresholdWindow: 'rolling12Months',
};

const transactionsRows: ReadonlyArray<Record<string, string | null>> = [
  {
    ...userContext,
    invoiceId: 'KqKVhzyHHq2StCc9jbLf',
    invoiceDate: '2022-01-31',
    invoiceNumber: '2',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    transactionId: '0',
    transactionDate: '2022-02-04',
    transactionSum: '1000.00',
    transactionVat: '0.00',
    transactionExchangeRate: '2.9867',
    transactionWithheldTax: '0.00',
  },
  {
    ...userContext,
    invoiceId: '2WUWx9RkulxrmMuPQCcb',
    invoiceDate: '2022-02-28',
    invoiceNumber: '3',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    transactionId: '0',
    transactionDate: '2022-03-04',
    transactionSum: '1000.00',
    transactionVat: '0.00',
    transactionExchangeRate: '3.2744',
    transactionWithheldTax: '0.00',
  },
  {
    ...userContext,
    invoiceId: '8yYW320fAfIbkZEpvDau',
    invoiceDate: '2022-03-31',
    invoiceNumber: '4',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    transactionId: '0',
    transactionDate: '2022-04-04',
    transactionSum: '1000.00',
    transactionVat: '0.00',
    transactionExchangeRate: '3.0902',
    transactionWithheldTax: '0.00',
  },
  {
    ...userContext,
    invoiceId: '8yYW320fAfIbkZEpvDau',
    invoiceDate: '2022-03-31',
    invoiceNumber: '4',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    transactionId: '1',
    transactionDate: '2022-04-04',
    transactionSum: '1000.00',
    transactionVat: '0.00',
    transactionExchangeRate: '3.0902',
    transactionWithheldTax: '0.00',
  },
];

const transactionsQuery = `
  SELECT
  * FROM
  \`invoicemaker-f5e1d.mini_accountant.transactions_slice_by_range\`(
    PARSE_TIMESTAMP("%Y%m%d",  "20220101", "Asia/Tbilisi"),
    PARSE_TIMESTAMP("%Y%m%d", "20231231", "Asia/Tbilisi"),
    "Asia/Tbilisi"
  );
  `;

export { transactionsRows, transactionsQuery };
